<template>
  <div
    v-if="session.startup_application"
    :class="{
      'opacity-50 cursor-not-allowed pointer-event':
        inProgress ||
        (session.startup_application.status != '0' &&
          session.startup_application.status != '11')
    }"
  >
    <h1 class="text-bold text-blue mb-5" v-if="session.session_name">{{ session.session_name.name }}</h1>
    <h2
      class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b"
    >{{ $t("team.editMember") }}</h2>

    <div
      v-if="isSubmitted && errors == null"
      class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.submitted") }}</strong>
      </p>
    </div>
    <div
      v-if="errors.length"
      class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.infinsh") }}</strong>
      </p>
      <!-- <ul class="error-messages block sm:inline text-left p-0 list-reset">
        <li v-for="(error,index) in errors" :key="index">
          <span v-if="error.message && Array.isArray(error.message)">{{ error.message[0] }}</span>
          <span v-else-if="error.message">{{ error.message }}</span>
        </li>
      </ul>-->
    </div>

    <form autocomplete="off" name="teamEdit" v-on:submit.prevent="editTeam()">
      <div class="flex my-8 max-w-md">
        <div class="flex-1 px-4 py-2">
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('firstname') || !team.firstname"
          >{{ getFieldMsgError('firstname') || $t("team.firstname") +' '+ $t("form.required")}}</span>
          <sp-input
            class="mt-3"
            :class=" !team.firstname ? 'has-error input' : ''"
            theme="team"
            name="firstname"
            v-model="team.firstname"
            :label="$t('team.firstname')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('lastname') || !team.lastname"
          >{{ getFieldMsgError('lastname') || $t("team.lastname") +' '+ $t("form.required")}}</span>
          <sp-input
            class="mt-3"
            :class="!team.lastname ? 'has-error input' : ''"
            theme="team"
            name="lastname"
            v-model="team.lastname"
            :label="$t('team.lastname')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('gender') || !team.gender"
          >{{ getFieldMsgError('gender') || $t("team.gender") +' '+ $t("form.required")}}</span>
          <sp-select
            class="mt-3"
            :class="!team.gender ? 'has-error input' : ''"
            theme="team"
            name="gender"
            v-model="team.gender"
            :label="$t('team.gender')"
            :options="genderList"
            :selected="team.gender"
            :required="true"
          ></sp-select>
          <!-- <div class="form-control relative mt-3">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('birthDate') || !team.birthDate"
            >{{ getFieldMsgError('birthDate') || $t("team.birthDate") +' '+ $t("form.required")}}</span>
            <label class="date-required block text-blue text-2sm font-bold mb-3">{{ $t("team.birthDate") }}</label>
            <flat-picker
              v-model="team.birthDate"
              placeholder="Date de naissance"
              :config="{ dateFormat: 'Y-m-d' }"
              :class="!team.birthDate ? 'has-error-date border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight' : 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight'"
            ></flat-picker>
          </div> -->
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('role') || !team.role"
          >{{ getFieldMsgError('role') || $t("team.roleProject") +' '+ $t("form.required")}}</span>
          <sp-input
            class="mt-3"
            :class="!team.role ? 'has-error input' : ''"
            theme="team"
            name="role"
            v-model="team.role"
            :label="currentUser.role != 'sso' ? $t('team.roleProject') : $t('ecosystem.roleSso')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('email') || !team.email"
          >{{ getFieldMsgError('email') || $t("team.email") +' '+ $t("form.required")}}</span>
          <sp-input
            class="mt-3"
            :class="!team.email ? 'has-error input' : ''"
            theme="team"
            name="email"
            v-model="team.email"
            :label="$t('team.email')"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('phone') || !team.phone"
          >{{ getFieldMsgError('phone') || $t("team.phone") +' '+ $t("form.required")}}</span>
          <sp-input
            class="mt-3"
            :class="!team.phone ? 'has-error input' : ''"
            theme="team"
            name="phone"
            v-model="team.phone"
            :label="$t('team.phone')"
            :required="true"
          ></sp-input>
          <!-- <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('short_bio') || !team.short_bio"
          >{{ getFieldMsgError('short_bio') || $t("team.shortBio_required") +' '+ $t("form.required")}}</span>
          <sp-textarea
            class="mt-3"
            :class="!team.short_bio ? 'has-error textarea' : ''"
            theme="team"
            v-model="team.short_bio"
            name="short_bio"
            id="short_bio"
            :label="$t('team.shortBio')"
            :required="true"
            :maxWords="300"
          ></sp-textarea>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('linkedin_url') || !team.linkedin_url"
          > {{getFieldMsgError('linkedin_url') ? getFieldMsgError('linkedin_url') : $t("team.linkedinUrl") +' '+ $t("form.required")}}</span>
          <sp-input
            :class="validateFieldError('linkedin_url') || !team.linkedin_url ? 'has-error input' : ''"
            theme="team-i"
            name="linkedin_url"
            v-model="team.linkedin_url"
            :value="team.linkedin_url"
            :label="$t('team.linkedinUrl')"
            :required="true"
            icon2="fa-linkedin-in"
          ></sp-input> -->

          <!-- <div class="form-control relative mb-5">
            <label class="block text-blue text-2sm font-bold mb-3">{{ $t('team.isYouTn') }}</label>
            <sp-radio
              theme="team"
              v-model="team.is_tunisian"
              v-for="(op, index) in [{name:'Oui',value:true},{name:'Non',value:false}]"
              :key="index"
              :value="op.value"
              :name="'radio'+index"
              :id="'radio'+index"
            >{{ op.name }}</sp-radio>
          </div>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="(validateFieldError('country') || !team.country) && !team.is_tunisian"
          >{{ getFieldMsgError('country') || $t("team.country") +' '+ $t("form.required")}}</span> -->

          <!-- <div v-if="!team.is_tunisian" class="form-control relative mt-3">
            <sp-select-country
              v-model="team.country"
              :class="!team.country && !team.is_tunisian ? 'has-error checkmark' : ''"
              :selected="team.country"
              theme="team"
              label="Sélectionnez votre pays de nationalité"
              placeholder="Sélectionner"
              :required="true"
            ></sp-select-country>
          </div>

          <div class="form-control relative">
            <div
              v-if="invalidfield"
              class="border border-red-light text-sm text-red-dark px-4 py-3 mb-4 rounded relative"
              role="alert"
            >
              <ul class="error-messages block sm:inline text-left p-0 list-reset">
                <li>{{ errorMessage }}</li>
              </ul>
            </div>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="(validateFieldError('cin_number') || !team.cin_number) && team.is_tunisian"
            >{{ getFieldMsgError('cin_number') || $t("team.cinNumber") +' '+ $t("form.required")}}</span>
            <sp-input
              class="mt-3"
              :class="!team.cin_number && team.is_tunisian ? 'has-error input' : ''"
              v-if="team.is_tunisian"
              theme="team"
              v-model="team.cin_number"
              name="cin_number"
              id="cin_number"
              :label="$t('team.cinNumber')"
              :required="true"
            ></sp-input>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="(!team.passport_number) && team.is_tunisian == false"
            >{{ getFieldMsgError('passeport') || $t("team.passportNumber") +' '+ $t("form.required")}}</span>
            <sp-input
              class="mt-3"
              :class="!team.passport_number  && team.is_tunisian == false ? 'has-error input' : ''"
              v-if="!team.is_tunisian"
              theme="team"
              v-model="team.passport_number"
              name="passport_number"
              id="passport_number"
              :label="$t('team.passportNumber')"
              :required="true"
            ></sp-input>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="!team.cin_file && team.is_tunisian"
            >{{ getFieldMsgError('cin_file') || $t("team.cin_file_required") +' '+ $t("form.required")}}</span>          
            <sp-dropzone
              class="mt-3"
              :class="!team.cin_file && team.is_tunisian ? 'has-error .dropzone.vue-dropzone' : ''"
              v-if="team.is_tunisian"
              theme="team"
              id="cin"
              :cinFile="team.cin_file"
              :url="url"
              :label="$t('team.cinUpload')"
              :required="true"
              :vdropzonesuccess="dropzoneSuccess"
              :vdropzoneError="vdropzoneError"
              type="0"
              acceptedFiles="application/pdf"
              :vdropzone-removed-file="vdropzoneRemovedFile"
              :vdropzoneProcessing="vdropzoneProcessing"
              :maxFiles="maxFiles"
            ></sp-dropzone> 
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="(!team.passport_file && team.is_tunisian == false) || passportFileError"
            >{{ getFieldMsgError('passeport_file') || $t("team.passeport_file_required") +' '+ $t("form.required")}}</span>
            <sp-dropzone
              class="mt-3"
              :class="( (!team.passport_file && team.is_tunisian == false) || passportFileError) ? 'has-error .dropzone.vue-dropzone' : ''"
              v-if="!team.is_tunisian"
              theme="team"
              id="passport"
              :passportFile="team.passport_file"
              :url="url"
              :label="$t('team.cinPasseport')"
              :required="true"
              :vdropzonesuccess="dropzoneSuccess"
              :vdropzoneError="vdropzoneError"
              type="0"
              acceptedFiles="application/pdf"
              :vdropzone-removed-file="vdropzonePassportRemovedFile"
              :vdropzoneProcessing="vdropzoneProcessing"
              :maxFiles="maxFiles"
            ></sp-dropzone>
          </div> -->
        </div>
      </div>

      <!-- <div class="max-w-md">
        <div>
          <h2
            class="text-blue text-base text-bold my-5 pb-2 border-grey-light border-b"
          >{{ $t("team.cvDetails") }}</h2>
          

          <div class="flex justify-between mb-4">
            <div class="text-blue text-2sm font-bold">{{ $t("team.experience") }}</div>
          </div>

          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('experienceYears') || !team.working_years"
          > {{ $t("team.experienceYears") +' '+ $t("form.required") }} </span>
          <sp-input
          :class="!team.working_years ? 'has-error input' : ''"
            theme="team"
            name="experienceYears"
            v-model="team.working_years"
            :label="$t('team.experienceYears')"
            :type="'number'"
            :required="true"
          ></sp-input>
          <div class="form-control relative mb-5">
            <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('cofoundedOtherStartups') || team.cofoundedOtherStartups == null "
          > {{ $t("team.cofoundedOtherStartups") +' '+ $t("form.required") }} </span>
            <label class="block text-blue text-2sm font-bold mb-3 date-required">{{ $t('team.cofoundedOtherStartups') }}</label>
            <sp-radio
              theme="team"
              :required="true"
              :class="team.cofoundedOtherStartups == null ? 'has-error checkmark' : ''"
              v-model="team.cofoundedOtherStartups"
              v-for="(op, index) in [{name:'Oui',value:true},{name:'Non',value:false}]"
              :key="index"
              :value="op.value"
              :name="'cofounded-in-other-startups-radio'+index"
              :id="'cofounded-in-other-startups-radio'+index"
            >{{ op.name }}</sp-radio>
            <sp-textarea
              class="mt-3"
              v-if="team.cofoundedOtherStartups"
              theme="team"
              v-model="team.cofoundedOtherStartupsDetails"
              name="cofounded-in-other-startups-description"
              id="cofounded-in-other-startups-description"
              label="Si oui laquelle ?"
            ></sp-textarea>
          </div>
          <div class="form-control relative mb-5">
            <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('workedInStartup') || team.workedInStartup == null "
          > {{ $t("team.workedInStartup") +' '+ $t("form.required") }} </span>
            <label class="block text-blue text-2sm font-bold mb-3 date-required">{{ $t('team.workedInStartup') }}</label>
            <sp-radio
              theme="team"
              :required="true"
              v-model="team.workedInStartup"
              v-for="(op, index) in [{name:'Oui',value:true},{name:'Non',value:false}]"
              :key="index"
              :value="op.value"
              :name="'worked-in-startup-radio'+index"
              :id="'worked-in-startups-radio'+index"
            >{{ op.name }}</sp-radio>
            <sp-textarea
              class="mt-3"
              v-if="team.workedInStartup"
              theme="team"
              v-model="team.workedInStartupDetails"
              name="worked-in-startup-description"
              id="worked-in-startup-description"
              label="Si oui laquelle ?"
            ></sp-textarea>
          </div>


          <div class="flex justify-end mb-4">
            <div>
              <sp-button theme="info" type="button" space="small" class @click="showExperience">
                <i class="far fa-plus-square mr-2"></i>
                {{ $t("team.addExperience") }}
              </sp-button>
            </div>
          </div>
      
          <div class="form mb-8" v-if="experienceAdd">
            <div
              v-if="experienceError.length"
              class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
              role="alert"
            >
              <p class="mb-0">
                <strong class="font-bold">{{ $t("form.shouldCorrectErrors") }}</strong>
              </p>
            </div>
            <span class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showExperienceErrors && !experience.title"
          >{{ $t('team.title') +' '+ $t("form.required")}}</span>
            <sp-input
              :required="true"
              :class="showExperienceErrors && !experience.title ? 'has-error input' : ''"
              theme="team"
              name="title"
              v-model="experience.title"
              :label="$t('team.title')"
            ></sp-input>
            <span class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showExperienceErrors && !experience.company"
          >{{ $t('team.company') +' '+ $t("form.required")}}</span>
            <sp-input
              :required="true"
              :class="showExperienceErrors && !experience.company ? 'has-error input' : ''"
              theme="team"
              name="company"
              v-model="experience.company"
              :label="$t('team.company')"
            ></sp-input>
            <span class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showExperienceErrors && !experience.location"
          >{{ $t('team.location') +' '+ $t("form.required")}}</span>
            <sp-input
              :required="true"
              :class="showExperienceErrors && !experience.location ? 'has-error input' : ''"
              theme="team"
              name="location"
              v-model="experience.location"
              :label="$t('team.location')"
            ></sp-input>
            <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showExperienceErrors && (!experience.to_year || !experience.from_year)"
          >{{ $t('team.fromTODate')}}</span>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="showExperienceErrors && fromDateGreaterThanToDate(experience)"
            >{{ $t('team.fromDateGreaterThanToDate')}}</span>
            <label class="block text-blue text-2sm font-bold mb-3 date-required">{{ $t("team.selectDate") }}</label>
            <flat-picker
              :required="true"
              :class="showExperienceErrors && !experience.from_year ? 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight has-error-date' : 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight'"
              v-model="experience.from_year"
              placeholder="Date de début"
              :config="{ dateFormat: 'Y-m-d' }"
            ></flat-picker>
            <flat-picker
              :required="true"
              :class="showExperienceErrors && !experience.to_year ? 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight has-error-date' : 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight'"
              v-if="!experience.currently_work"
              v-model="experience.to_year"
              placeholder="Date de fin"
              :config="{ dateFormat: 'Y-m-d' }"
            ></flat-picker>
            <sp-checkbox
              theme="default"
              name="option"
              id="currently_work"
              :checked="experience.currently_work"
              @input="checkboxUpdate"
            >{{ $t("team.currentWork") }}</sp-checkbox>
            <sp-textarea
              theme="team"
              v-model="experience.description"
              name="description"
              id="description"
              label="Description"
            ></sp-textarea>

            <sp-button
              theme="outline-blue"
              space="small"
              class
              @click="addExperience"
            >{{ $t("team.save") }}</sp-button>
          </div>

          <div class="bg-grey-lighter border border-blue-lightest rounded mb-8 g-experience">
            <div
              class="card-a border-blue-lightest border-b m-4 mb-0 pb-4"
              v-for="(experience, index) in team.experience"
              :key="index"
            >
              <div class="flex justify-between mb-4">
                <div class="text-grey-darker text-sm font-bold mb-3">
                  <h4>{{ experience.title }}</h4>
                </div>
                <div>
                  <i class="far fa-edit p-2" @click="editExperience(index)"></i>
                  <i class="fas fa-trash-alt" @click="removeExperience(index)"></i>
                </div>
              </div>
              <p class="text-grey-darker text-sm mb-2">{{ experience.company }}</p>
              <p class="text-grey-darker text-sm">
                {{ experience.from_year }} - {{ experience.to_year }}
                {{ experience.location }}
              </p>
            </div>
          </div>
           
          <div class="flex justify-between mb-4">
            <div class="text-blue text-2sm font-bold">{{ $t("team.educationDetails") }}</div>
          </div>

          

          <div class="form-control relative mt-3">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('studyLevel') || !team.studyLevel"
            >{{ getFieldMsgError('studyLevel') || $t("team.studyLevel") +' '+ $t("form.required")}}</span>
            <sp-select
              class="mt-3"
              :class="!team.studyLevel ? 'has-error input' : ''"
              theme="team"
              name="gender"
              v-model="team.studyLevel"
              :label="$t('team.studyLevel')"
              :options="studyLevelList"
              :selected="team.studyLevel"
              :required="true"
            ></sp-select>
          </div>
          <div class="form-control relative mt-3 mb-6">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('academicBackground') || !team.academicBackground"
            >{{ getFieldMsgError('academicBackground') || $t("team.academicBackground") +' '+ $t("form.required")}}</span>
            <sp-select
              class="mt-3"
              :class="!team.academicBackground ? 'has-error input' : ''"
              theme="team"
              name="academicBackground"
              v-model="team.academicBackground"
              :label="$t('team.academicBackground')"
              :options="academicBackgroundList"
              :selected="team.academicBackground"
              :required="true"
            ></sp-select>
          </div>
          


          <div class="flex justify-end mb-4">
            <div>
              <sp-button theme="info" type="button" space="small" class @click="showEducation">
                <i class="far fa-plus-square mr-2"></i>
                {{ $t("team.addEducation") }}
              </sp-button>
            </div>
          </div>

          <div class="form mb-8" v-if="educationAdd">
            <div
              v-if="educationError.length"
              class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
              role="alert"
            >
              <p class="mb-0">
                <strong class="font-bold">{{ $t("form.shouldCorrectErrors") }}</strong>
              </p>
            </div>
            <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showEducationErrors && !education.school"
          >{{ $t('team.school') +' '+ $t("form.required")}}</span>
            <sp-input
              :required="true"
              :class="showEducationErrors && !education.school ? 'has-error input' : ''"
              class="mt-3"
              theme="team"
              name="school"
              v-model="education.school"
              :label="$t('team.school')"
            ></sp-input>
            <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showEducationErrors && !education.degree"
          >{{ $t('team.degree') +' '+ $t("form.required")}}</span>
            <sp-input
              :required="true"
              :class="showEducationErrors && !education.degree ? 'has-error input' : ''"
              theme="team"
              name="degree"
              v-model="education.degree"
              :label="$t('team.degree')"
            ></sp-input>
            <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showEducationErrors && !education.field_study"
          >{{ $t('team.fieldStudy') +' '+ $t("form.required")}}</span>
            <sp-input
              :required="true"
              :class="showEducationErrors && !education.field_study ? 'has-error input' : ''"
              theme="team"
              name="field_study"
              v-model="education.field_study"
              :label="$t('team.fieldStudy')"
            ></sp-input>
            <span class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="showEducationErrors && !education.location"
            >{{ $t('team.location') +' '+ $t("form.required")}}</span>
            <sp-input
              :required="true"
              :class="showEducationErrors && !education.location ? 'has-error input' : ''"
              theme="team"
              name="location"
              v-model="education.location"
              :label="$t('team.location')"
            ></sp-input>

             <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showEducationErrors && (!education.to_year || !education.from_year)"
          >{{ $t('team.fromTODate') }}</span>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="showEducationErrors && fromDateGreaterThanToDate(education)"
          >{{ $t('team.fromDateGreaterThanToDate')}}</span>
            <label class="block text-blue text-2sm font-bold mb-3 date-required">{{ $t("team.selectDate") }}</label>
            <flat-picker
              :required="true"
              :class="showEducationErrors && !education.from_year ? 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight has-error-date' : 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight'"
              v-model="education.from_year"
              placeholder="Date de début"
              :config="{ dateFormat: 'Y-m-d' }"
            ></flat-picker>
            <flat-picker
              :required="true"
              :class="showEducationErrors && !education.to_year ? 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight has-error-date' : 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight'"
              v-model="education.to_year"
              placeholder="Date de fin"
              :config="{ dateFormat: 'Y-m-d' }"
            ></flat-picker>
            <sp-textarea
              theme="team"
              v-model="education.description"
              name="description"
              id="description"
              label="Description"
            ></sp-textarea>
            <sp-button
              theme="outline-blue"
              space="small"
              class
              @click="addEducation"
            >{{ $t("team.save") }}</sp-button>
          </div>

          <div class="bg-grey-lighter border border-blue-lightest rounded mb-8 g-education">
            <div
              class="card-a border-blue-lightest border-b m-4 mb-0 pb-4"
              v-for="(education, index) in team.education"
              :key="index"
            >
              <div class="flex justify-between mb-4">
                <div class="text-grey-darker text-sm font-bold mb-3">
                  <h4>{{ education.school }}</h4>
                </div>
                <div>
                  <i class="far fa-edit p-2" @click="editEducation(index)"></i>
                  <i class="fas fa-trash-alt" @click="removeEducation(index)"></i>
                </div>
              </div>
              <p class="text-grey-darker text-sm mb-2">{{ education.field_study }}</p>
              <p class="text-grey-darker text-sm">
                {{ education.from_year }} - {{ education.to_year }}
                {{ education.location }}
              </p>
            </div>
          </div>

          
        </div>
      </div> -->
      <div
        class="flex items-center justify-end w-auto bg-white shadow-box mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
      >
        <sp-button
          theme="outline-blue"
          space="small"
          :disabled="
            (session.startup_application.status != '0' &&
              session.startup_application.status != '11') ||
              inProgress
          "
          class
          type="submit"
        >{{ $t("team.save") }}</sp-button>
      </div>
    </form>
  </div>
</template>

<style>
.form-control--icon2 {
  top: 1.9rem;
  left: 0.05rem;
  height: 2.7rem;
}

.g-education .card-a:last-child,
.g-experience .card-a:last-child {
  border: none;
}
.loader {
  height: 100px;
  width: 80%;
  text-align: center;
  padding: 1em;
  margin: 0 auto 1em;
  display: inline-block;
  vertical-align: top;
}
.loader svg path,
.loader svg rect {
  fill: #ff6700;
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 40%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.card.container {
  padding: 2px 16px;
}

.bg-red-lighter {
    background-color: #fce4e4 !important;
}

.has-error-date,
.has-error input,
.has-error textarea,
.has-error .dropzone.vue-dropzone,
.has-error .checkmark,
.has-error .ui.fluid.dropdown {
    border-color: #a94442 !important;
    background-color: #fce4e4 !important;
}

.date-required:after {
    content:" *";
    color: red;
}
.pointer-event {
  pointer-events: none
}
</style>

<script>
import { ValidationProvider } from "vee-validate";
import DropZoneVue from "../../components/spKit/DropZone.vue";
import InputVue from "../../components/spKit/Input.vue";
import TextareaVue from "../../components/spKit/Textarea.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import Link from "@/components/spKit/Link.vue";
import flatPickr from "vue-flatpickr-component";
import Select from "@/components/spKit/Select.vue";
import "flatpickr/dist/flatpickr.css";
import { EDIT_TEAM, GET_TEAM, FETCH_ECOSYSTEM_APPLICATION, CHECK_AUTH } from "@/store/actions.type";
import { SET_ECOSYSTEM_MENU_ACTIVE } from "@/store/mutations.type";
import { mapGetters, mapState } from "vuex";

import { API_URL } from "@/common/config";
import CheckboxVue from "../../components/spKit/Checkbox.vue";
const uploadURL = API_URL + "/documents/upload";
import SelectCountryVue from "../../components/spKit/selectCountry/SelectCountry.vue";
import RadioVue from "../../components/spKit/Radio.vue";
export default {
  name: "teamEdit",
  components: {
    ValidationProvider,
    "sp-dropzone": DropZoneVue,
    "sp-input": InputVue,
    "sp-textarea": TextareaVue,
    "sp-button": ButtonVue,
    "sp-link": Link,
    "flat-picker": flatPickr,
    "sp-checkbox": CheckboxVue,
    "sp-select-country": SelectCountryVue,
    "sp-select": Select,
    "sp-radio": RadioVue
  },
  data() {
    return {
      passportFileError: false,
      url: uploadURL,
      maxFiles: 1,
      inProgress: false,
      isSubmitted: false,
      invalidfield: "",
      fileUpload: [],
      passportFileUplaod: [],
      experienceAdd: false,
      educationAdd: false,
      errors: [],
      teamErrors: [],
      experienceError: [],
      educationError: [],
      showEducationErrors: false,
      showExperienceErrors: false,
      experience: {
        title: null,
        company: null,
        location: null,
        from_year: null,
        to_year: null,
        currently_work: false,
        description: null
      },
      education: {
        school: null,
        degree: null,
        field_study: null,
        location: null,
        from_year: null,
        to_year: null,
        description: null
      },
      team: {
        name: null,
        gender: null,
        birthDate: null,
        email: null,
        short_bio: null,
        cin_number: null,
        cin_file: null,
        passport_number: null,
        passport_file: null,
        role: null,
        experience: [],
        education: [],
        is_tunisian: true,
        country: null,
        cofoundedOtherStartups: null,
        workedInStartup: null,
        cofoundedOtherStartupsDetails: null,
        workedInStartupDetails: null,
        studyLevel: null,
        academicBackground: null
      },
      genderList:[
        { name : "Homme", value : "1"},
        { name : "Femme", value : "2"}
      ],
      studyLevelList:[
        { name : "Licence - maitrise", value : "1"},
        { name : "Technicien superieur, B.T.S", value : "2"},
        { name : "Mastere", value : "3"},
        { name : "Premier cycle universitaire", value : "4"},
        { name : "Ingenieur", value : "5"},
        { name : "D.E.A, doctorat", value : "6"},
        { name : "Architecte", value : "7"},
        { name : "Medecin, pharmacien, medecin dentaire", value : "8"},
        { name : "Dip nat: art&metiers, art&design, audiovisuel", value : "9"},
        { name : "Bac et plus sans diplome", value : "10"},
        { name : "Secondaire, B.T.P", value : "11"},
        { name : "Ecole de base, C.A.P, apprenti", value : "12"}
      ],
      academicBackgroundList:[
        { name : "Agriculture, sylviculture et pêche et études vétérinaires", value : "1"},
        { name : "Biologie", value : "2"},
        { name : "Lettre, langues et Arts", value : "3"},
        { name : "Sciences humaines et sociales", value : "4"},
        { name : "Ingénieurie et technologie", value : "5"},
        { name : "Droit et sciences politiques", value : "6"},
        { name : "Mathématiques et statistiques", value : "7"},
        { name : "Medecine et santé", value : "8"},
        { name : "Sciences physiques et environnement", value : "9"},
        { name : "Economie et gestion", value : "10"},
        { name : "Sport, tourisme et services", value : "11"},
        { name : "Journalisme et information", value : "12"},
        { name : "Autre", value : "13"}
      ]
    };
  },
  async mounted() {    
    await this.$store.dispatch(CHECK_AUTH).then(role => {
      let isEcosystem = role == 'sso' || localStorage.getItem('ecosystem') === 'true' ? true : false;
      if (isEcosystem) {
      this.$store
        .dispatch(FETCH_ECOSYSTEM_APPLICATION, this.$route.params.app_id);
      this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
    }
    if (this.isStartupEcosystem) {
      this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
    }
    this.$store
      .dispatch(GET_TEAM, {
        app_id: this.$route.params.app_id,
        team_id: this.$route.params.team_id,
        ecosystem: isEcosystem
      })
      .then(({ data }) => {
        if(!data.team_member.is_tunisian){
          data.team_member.passport_number = data.team_member.cin_number
          data.team_member.passport_file = data.team_member.cin_file
          data.team_member.cin_number = null
          data.team_member.cin_file = null
        }
        if(!data.team_member.workedInStartup){
          data.team_member.workedInStartupDetails = null
        }
        if(data.team_member.workedInStartupDetails == "Oui"){
          data.team_member.workedInStartupDetails = null
        }
        if(!data.team_member.cofoundedOtherStartups){
          data.team_member.cofoundedOtherStartupsDetails = null
        }
        if(data.team_member.cofoundedOtherStartupsDetails == "Oui"){
          data.team_member.cofoundedOtherStartupsDetails = null
        }
        this.team = data.team_member;
        this.team.is_tunisian = Boolean(data.team_member.is_tunisian);
      })
      .catch(() => {
        this.$router.push({ name: "home" });
      });
      
      })
  },
  methods: {
    checkboxUpdate(check) {
      this.experience.currently_work = check;
    },
    editTeam() {
      window.scrollTo(0, 0);
      this.$Progress.start();
      this.inProgress = true;
      if(this.team.passport_number && !this.team.is_tunisian){
        this.team.cin_number = this.team.passport_number
      }
      if(this.team.passport_file && !this.team.is_tunisian){
        this.team.cin_file = this.team.passport_file
      }
      let teamForm = Object.assign({}, this.team);
      if (teamForm.cin_file) teamForm.cin_file = this.team.cin_file.id;
      if (typeof this.fileUpload[0] != "undefined")
        teamForm.cin_file = this.fileUpload[0];

      if(typeof this.passportFileUplaod[0] != "undefined"){
        teamForm.passport_file = this.passportFileUplaod[0];
      }
      if (teamForm.experience)
        teamForm.experience.currently_work = Number(teamForm.currently_work);
      if (!this.team.linkedin_url) delete teamForm["linkedin_url"];
      let isEcosystem = false;
      if (
        this.currentUser.role == "sso" ||
        (this.currentUser.role == "Startup" &&
          this.ecosystemApp && this.ecosystemApp.application &&
          ["Air", "Air2", "D4D"].includes(this.ecosystemApp.application.type))
      ) {
        isEcosystem = true;
      }
      this.$store
        .dispatch(EDIT_TEAM, {
          app_id: this.$route.params.app_id,
          team: teamForm,
          ecosystem: isEcosystem
        })
        .then(() => {
          this.$Progress.finish();
          this.inProgress = false;
          this.$router.push({
            name: isEcosystem ? "FormChecklist" : "FormChecklist",
            params: {
              app_id: this.$route.params.app_id
            }
          });
        })
        .catch(({ response }) => {
          this.$Progress.fail();
          this.inProgress = false;
          if (response) this.errors = response.data.meta.errors;
        });
      window.scrollTo(0, 0);
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    showExperience() {
      this.experienceError = [];
      this.experience = {
        title: null,
        company: null,
        location: null,
        from_year: null,
        to_year: null,
        currently_work: false,
        description: null
      };
      this.experienceAdd = !this.experienceAdd;
    },
    showEducation() {
      this.educationError = [];
      this.education = {
        school: null,
        degree: null,
        field_study: null,
        location: null,
        from_year: null,
        to_year: null,
        description: null
      };
      this.educationAdd = !this.educationAdd;
    },
    hidexperience() {
      this.experienceError = [];
      this.experienceAdd = !this.experienceAdd;
    },
    hideEducation() {
      this.educationError = [];
      this.educationAdd = !this.educationAdd;
    },
    addExperience() {
      this.experienceError = [];
      if (!this.experience.title)
        this.experienceError.push("Titre est obligatoire");
      if (!this.experience.company)
        this.experienceError.push("Société est obligatoire");
      if (!this.experience.location)
        this.experienceError.push("Lieu est obligatoire");
      if (!this.experience.from_year)
        this.experienceError.push("Date début est obligatoire");
      if (!this.experience.to_year && !this.experience.currently_work)
        this.experienceError.push("Date fin est obligatoire");
      if (this.fromDateGreaterThanToDate(this.experience)) {
        this.experienceError.push("La date de début doit être inférieure à la date de fin");
      }

      this.showExperienceErrors = true

      if (this.experienceError.length > 0) return true;
      if (this.experience.currently_work) this.experience.to_year = null;

      if (this.experience.edit !== undefined) {
        this.team.experience[this.experience.edit] = this.experience;
      } else this.team.experience.push(this.experience);
      this.showExperience();
      this.experience = {
        title: null,
        company: null,
        location: null,
        from_year: null,
        to_year: null,
        currently_work: false,
        description: null
      };
      this.showExperienceErrors = false;
    },
    addEducation() {
      this.educationError = [];
      if (!this.education.school)
        this.educationError.push("Faculté est obligatoire");
      if (!this.education.degree)
        this.educationError.push("Diplôme est obligatoire");
      if (!this.education.field_study)
        this.educationError.push("Domaine d'étude est obligatoire");
      if (!this.education.from_year)
        this.educationError.push("Date début est obligatoire");
      if (!this.education.to_year)
        this.educationError.push("Date fin est obligatoire");
      if (!this.education.location)
        this.educationError.push("Lieu est obligatoire");
      if (this.fromDateGreaterThanToDate(this.education)) {
        this.educationError.push("La date de début doit être inférieure à la date de fin");
      }
      
      this.showEducationErrors = true
      
      if (this.educationError.length > 0) return true;
      if (this.education.edit !== undefined) {
        this.team.education[this.education.edit] = this.education;
      } else this.team.education.push(this.education);
      this.showEducation();
      this.education = {
        school: null,
        degree: null,
        field_study: null,
        location: null,
        from_year: null,
        to_year: null,
        description: null
      };
      this.showEducationErrors = false;
    },
    editExperience(index) {
      if (this.team.experience.hasOwnProperty(index)) {
        this.hidexperience();
        this.experience = this.team.experience[index];
        this.experience.edit = index;
      }
    },
    editEducation(index) {
      if (this.team.education.hasOwnProperty(index)) {
        this.hideEducation();
        this.education = this.team.education[index];
        this.education.edit = index;
      }
    },
    removeExperience(index) {
      if (this.team.experience.hasOwnProperty(index))
        this.team.experience.splice(index, 1);
    },
    removeEducation(index) {
      if (this.team.education.hasOwnProperty(index))
        this.team.education.splice(index, 1);
    },
    vdropzoneProcessing(file) {
      this.inProgress = true;
    },
    dropzoneSuccess(file, response) {
      if(this.team.is_tunisian){
      this.team.passport_file = null
      this.passportFileUplaod = []
      this.inProgress = false;
      this.fileUpload.push(response.data.document.id);
      this.team.cin_file = response.data.document;
      }else{
      this.team.cin_file = null
      this.fileUpload = []
      this.inProgress = false;
      this.passportFileUplaod.push(response.data.document.id);
      this.team.passport_file = response.data.document;
      this.passportFileError = false
      }
    },
    vdropzonePassportRemovedFile(file, error, xhr) {
      if(file.path && !this.team.is_tunisian){
         this.team.passport_file = null
         this.passportFileError = true
       }
      if (xhr != undefined) {
        let data = JSON.parse(file.xhr.response);
        if (data.meta.status == 200) {
          let index = this.passportFileUplaod.indexOf(data.data.document.id);
          if (index > -1) {
            this.passportFileUplaod.splice(index, 1);
          }
        }
      } else {
        let index = this.passportFileUplaod
          .map(function(x) {
            return x;
          })
          .indexOf(file.id);
        if (index > -1) {
          this.passportFileUplaod.splice(index, 1);
        }
      }
    },
    vdropzoneError(file, message, xhr) {
      if (xhr != undefined) {
        if (message.meta.status == 400) {
          if(this.team.is_tunisian){
            this.passportFileUplaod.splice(-1, 1);
          }else{
            this.fileUpload.splice(-1, 1);
          }
        } 
      }
      this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
        "you cant upload this file";
    },
    vdropzoneRemovedFile(file, error, xhr) {
       if(file.path && this.team.is_tunisian){
         this.team.cin_file = null
       }
      if (xhr != undefined) {
        let data = JSON.parse(file.xhr.response);
        if (data.meta.status == 200) {
          let index = this.fileUpload.indexOf(data.data.document.id);
          if (index > -1) {
            this.fileUpload.splice(index, 1);
          }
        }
      } else {
        let index = this.fileUpload
          .map(function(x) {
            return x;
          })
          .indexOf(file.id);
        if (index > -1) {
          this.fileUpload.splice(index, 1);
        }
      }
    },
    validateFieldError(field){
      const fieldHasError = ((this.errors).map(e => e.fields[0])).includes(field)
      return fieldHasError
    },
    getFieldMsgError(field){
      const errorMsg = ((this.errors).filter(e => e.fields[0] === field))
      if(errorMsg.length){
        let res = Array.isArray(errorMsg[0].message) ? (errorMsg[0].message)[0] : errorMsg[0].message
        res = res == "Le champ cin number doit contenir 8 chiffres." ? "Le champ Cin doit contenir 8 chiffres." : res
        return res
      }
      return ''
    },
    fromDateGreaterThanToDate(dataSource) {
      return dataSource.to_year && !dataSource.currently_work &&
        dataSource.from_year &&
        new Date(dataSource.from_year) > new Date(dataSource.to_year)
    }
  },
  computed: {
    ...mapGetters(["session", "currentUser","ecosystemApp"]),
    isStartupEcosystem() {
      let startupEco = false;
      if (this.$route.params.app_id) {
        let hashId = this.$route.params.app_id;
        if (
          this.ecosystemApp &&
          this.ecosystemApp.application &&
          ["Air", "Air2"].includes(this.ecosystemApp.application.type) &&
          this.ecosystemApp.application.id == hashId
        ) {
          startupEco = true;
        }
      }
      return startupEco;
    },
  },
  watch: {
    'team.cin_number': {
      handler(newVal, oldVal) {
         if(newVal && oldVal && this.team.is_tunisian){
           this.team.passport_number = null
         }
      },
  },
    'team.passport_number': {
      handler(newVal, oldVal) {
         if(newVal && oldVal && !this.team.is_tunisian){
           this.team.cin_number = null
         }
    },
  },
  },
  beforeDestroy() {
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, false);
  }
};
</script>

